module.exports = __webpack_public_path__ + "img/time.4fdcf6c5.png";